import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useParams, Link, useLocation } from 'react-router-dom';
import './UserMenu.css';
import HiddenImg from '../utils/HiddenImg';
import ErrorAlert from '../Alerts/ErrorAlert';
//Api 
import { MachinesFetchAPI } from '../../../api/Machines';
import FullScreen from '../../components/FullScreen'
import ModalSetting from '../Modals/SettingsPos/ModalSetting';
/**
 * UserMenu — reemplaza tu `userBox`. Popover hacia arriba (como el desglose) con 2 tabs.
 * Solo diseño + estado local; conecta tus handlers en las props.
 *
 * @param {string} [name='María Gómez']
 * @param {string} [role='Cajera · Arco Iris']
 * @param {string} [initials='MG']
 * @param {string} [email]
 * @param {()=>void} [onConfig]        Configuración
 * @param {()=>void} [onLogout]        Cerrar sesión
 * Ajustes de vista (controlados; pásalos si quieres, o deja que use su estado interno):
 * @param {boolean} [compact] @param {(v)=>void} [onCompactChange]
 * @param {boolean} [darkMode] @param {(v)=>void} [onDarkModeChange]
 * @param {'photo'|'list'} [menuLayout] @param {(v)=>void} [onMenuLayoutChange]
 */
export function UserMenu({
    name = 'María Gómez',
    role = 'Usuario',
    initials = '',
    email,
    onConfig,
    onLogout,
    compact, onCompactChange,
    darkMode, onDarkModeChange,
    menuLayout, onMenuLayoutChange,

    toggleHidden,
    hidden,

    setPageLoader, codeParthner
}) {
    const [open, setOpen] = useState(false);
    const [tab, setTab] = useState('cuenta'); // cuenta | vista
    const ref = useRef(null);

    // estado interno de respaldo si no se controla por props
    const [cCompact, setCCompact] = useState(false);
    const [cDark, setCDark] = useState(false);
    const [cLayout, setCLayout] = useState('photo');
    const vCompact = compact ?? cCompact;
    const vDark = darkMode ?? cDark;
    const vLayout = menuLayout ?? cLayout;
    const setCompact = (v) => (onCompactChange ? onCompactChange(v) : setCCompact(v));
    const setDark = (v) => (onDarkModeChange ? onDarkModeChange(v) : setCDark(v));
    const setLayout = (v) => (onMenuLayoutChange ? onMenuLayoutChange(v) : setCLayout(v));

    useEffect(() => {
        if (!open) return;
        const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
        document.addEventListener('mousedown', onDoc);
        document.addEventListener('keydown', onKey);
        return () => { document.removeEventListener('mousedown', onDoc); document.removeEventListener('keydown', onKey); };
    }, [open]);


    //Params 
    const navigate = useNavigate();
    let { business_code, branchoffice_code } = useParams();
    let user = localStorage.getItem('user');
    let token = localStorage.getItem('x-access-machine-token');
    let branchoffice = localStorage.getItem('branchoffice');
    let user_token = localStorage.getItem('x-access-token');
    const [showModalSetting, setshowModalSetting] = useState(false)
    //Location page 
    const url_path = useLocation();
    if (localStorage.getItem("x-access-machine-token") == "") {
        let business = JSON.parse(localStorage.getItem("business"))
        //navigate(`/machines/login/`+business.code)
        window.location.href = '/machines/login/' + business.code;
        console.log("hello");
    }

    //We validate if the user is logged in
    if (user === null || user === undefined || user === '' || user === 'null') {
        user = {
            name: 'No registrado',
            img: 'https://www.pngitem.com/pimgs/m/30-307416_profile-icon-png-image-free-download-searchpng-employee.png'
        }
    } else {
        user = JSON.parse(localStorage.getItem('user'));
    }

    //We validate if the branch
    if (branchoffice !== null && branchoffice !== undefined && branchoffice !== '') {
        branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    }

    //Function to logout of the payment post
    const signout = async () => {
        let machine_token = localStorage.getItem('x-access-machine-token');
        let machine = JSON.parse(localStorage.getItem('machine_original'));

        if (!machine || !machine.code) {
            ErrorAlert("No se encontró información de la máquina", "No se puede cerrar sesión correctamente", "error");
            return;
        }

        let liberada = false;
        let errorMsg = '';
        try {
            const response = await MachinesFetchAPI.updateMachineStatus(machine.code, false, machine_token);
            if (response.data && response.data.success === true) {
                liberada = true;
            } else {
                errorMsg = response.data && response.data.error ? response.data.error : 'No se pudo liberar la máquina.';
            }
        } catch (err) {
            errorMsg = err?.response?.data?.error || err?.message || 'Error de red al liberar la máquina.';
        }

        if (liberada) {
            localStorage.clear();
            navigate(`/machines/login/${business_code}`);
        } else {
            ErrorAlert("No se pudo liberar la máquina", errorMsg + "\nIntente nuevamente. Si el problema persiste, contacte a soporte.", "error");
        }
    }

    return (
        <div className={`sp-um ${open ? 'is-open' : ''}`} ref={ref}>

            {/* ── Popover ── */}
            <div className="sp-um__pop" role="menu" hidden={!open}>
                {/* Tabs */}
                <div className="sp-um__tabs">
                    <button className={`sp-um__tab ${tab === 'cuenta' ? 'is-active' : ''}`} onClick={() => setTab('cuenta')} type="button">
                        <i className="uil uil-user"></i> Cuenta
                    </button>
                    <button className={`sp-um__tab ${tab === 'vista' ? 'is-active' : ''}`} onClick={() => setTab('vista')} type="button">
                        <i className="uil uil-desktop"></i> Vista
                    </button>
                </div>

                {/* Tab: Cuenta */}
                {tab === 'cuenta' && (
                    <div className="sp-um__panel">
                        {/* <div className="sp-um__ident">
                            <div className="sp-um__av lg">{initials}</div>
                            <div className="sp-um__identinfo">
                                <div className="sp-um__name">{user.name} {user.lastName}</div>
                                 <div className="sp-um__role">{user.role}</div>
                                {email && <div className="sp-um__email">{user.email}</div>}
                            </div>
                        </div> */}

                        <div className="sp-um__list">
                        

                            <ModalSetting setPageLoader={setPageLoader} codeParthner={codeParthner}></ModalSetting>


                            <button className="sp-um__item sp-um__item--danger" onClick={onLogout} type="button" onClick={signout}>
                                <i className="uil uil-signout"></i> Cerrar sesión
                            </button>
                        </div>
                    </div>
                )}

                {/* Tab: Vista */}
                {tab === 'vista' && (
                    <div className="sp-um__panel">
                        <div className="sp-um__secttitle">Ajustes del POS</div>

                        {/* Layout del menú */}
                        {/* <div className="sp-um__field">
                            <span className="sp-um__flabel">Vista del menú</span>
                            <div className="sp-um__seg">
                                <button className={vLayout === 'photo' ? 'on' : ''} onClick={() => setLayout('photo')} type="button">Foto</button>
                                <button className={vLayout === 'list' ? 'on' : ''} onClick={() => setLayout('list')} type="button">Lista</button>
                            </div>
                        </div> */}

                        <HiddenImg isHidden={hidden} onToggle={toggleHidden} />

                        {/* Modo compacto */}
                        {/* <label className="sp-um__toggle">
                            <span><i className="uil uil-compress-arrows"></i> Modo compacto</span>
                            <input type="checkbox" checked={vCompact} onChange={(e) => setCompact(e.target.checked)} />
                            <span className="sp-um__switch" aria-hidden="true"></span>
                        </label> */}

                        <FullScreen />

                        {/* Modo oscuro */}
                        <label className="sp-um__toggle d-none">
                            <span><i className="uil uil-moon"></i> Modo oscuro</span>
                            <input type="checkbox" checked={vDark} onChange={(e) => setDark(e.target.checked)} />
                            <span className="sp-um__switch" aria-hidden="true"></span>
                        </label>
                    </div>
                )}

                <span className="sp-um__arrow" aria-hidden="true" />
            </div>

            {/* ── Caja de usuario (disparador) ── */}
            <button className="sp-user" onClick={() => setOpen((v) => !v)} aria-expanded={open} type="button">
                <div className="sp-user__av">{initials}</div>
                <div className="sp-user__info">
                    <div className="nm">{user.name} {user.lastName}</div>
                    <div className="rl">{role}</div>
                </div>
                <svg className="sp-user__cx" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <polyline points="6 15 12 9 18 15" />
                </svg>
            </button>
        </div>
    );
}

export default UserMenu;